import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Platform } from "@core/api";
import { PrivilegesLists, privilegesListsIds } from "../constants/PrivilegesConstants.js";
export var PrivilegesListActionTypes = {
    set: "SET_PRIVILEGES_LIST",
    remove: "REMOVE_PRIVILEGES_LIST",
    addPrivilege: "ADD_PRIVILEGES_TO_LIST",
    removePrivilege: "REMOVE_PRIVILEGES_FROM_LIST"
};
var _obj;
var privilegesListsUrls = (_obj = {}, _define_property(_obj, PrivilegesLists.Groups, function() {
    return Platform.organization.listPrivileges();
}), _define_property(_obj, PrivilegesLists.GlobalGroups, function() {
    return Platform.privileges.getGlobalGroupPrivileges();
}), _define_property(_obj, PrivilegesLists.ApiKeys, function() {
    return Platform.organization.listApiKeysPrivileges();
}), _define_property(_obj, PrivilegesLists.User, function() {
    return Platform.organization.listMyPrivileges();
}), _obj);
var addOrOverwrite = function(id, privileges) {
    return {
        type: PrivilegesListActionTypes.set,
        payload: {
            id: id,
            privileges: privileges
        }
    };
};
var remove = function(id) {
    return {
        type: PrivilegesListActionTypes.remove,
        payload: {
            id: id
        }
    };
};
var addToList = function(id, privileges) {
    return {
        type: PrivilegesListActionTypes.addPrivilege,
        payload: {
            id: id,
            privileges: privileges
        }
    };
};
var removeFromList = function(id, privileges) {
    return {
        type: PrivilegesListActionTypes.removePrivilege,
        payload: {
            id: id,
            privileges: privileges
        }
    };
};
var fetchPrivileges = function(param) {
    var list = param.list, id = param.id, done = param.done, fail = param.fail;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var listId, data, _tmp, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        listId = privilegesListsIds[list] || id;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!id) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            privilegesListsUrls[PrivilegesLists.Groups]()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            privilegesListsUrls[list]()
                        ];
                    case 4:
                        _tmp = _state.sent();
                        _state.label = 5;
                    case 5:
                        data = _tmp;
                        dispatch(addOrOverwrite(listId, data));
                        done === null || done === void 0 ? void 0 : done(data);
                        return [
                            2,
                            data
                        ];
                    case 6:
                        error = _state.sent();
                        fail === null || fail === void 0 ? void 0 : fail(error);
                        return [
                            2,
                            []
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var PrivilegesListActions = {
    addOrOverwrite: addOrOverwrite,
    remove: remove,
    fetchPrivileges: fetchPrivileges,
    addToList: addToList,
    removeFromList: removeFromList
};

//# sourceMappingURL=PrivilegesListActions.js.map